// Copyright (c) 2016 Deere & Company

import ClaimsSettings from './components/claims-settings';
import actionCreators from '../shared/action-creators';
import {connect} from 'react-redux';
import {handleOnPageLeave} from '../shared/services/handle-on-page-leave';

const getStateToBindToContainerProps = state => ({
    ...state.user.preferences,
    userClaimSettings: state.user.details.settings.claims
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps,
        handleOnPageLeave
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimsSettings);



// WEBPACK FOOTER //
// ./src/user/claims-settings/state-connector.js